import { fromJS, List, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import type { Link } from '#utils/linkUtils';
import type { MemberSummary } from '#utils/members/records/MemberSummary';
import { createMemberSummary } from '#utils/members/records/MemberSummary';

type TeamMaintainerSummaryLinksProps = {
  // Optional path to the next page of team maintainers.
  // If missing, there are no more team maintainers to load.
  // Example: /api/v2/teams/{key}/maintainers?limit=10&offset=20
  next?: Link;
};

class TeamMaintainerSummaryLinks extends Record<TeamMaintainerSummaryLinksProps>({
  next: undefined,
}) {}

type TeamMaintainerSummaryProps = {
  totalCount: number;
  items: List<MemberSummary>;
  _links: TeamMaintainerSummaryLinks;
  _isFetching: boolean;
};

export class TeamMaintainerSummary extends Record<TeamMaintainerSummaryProps>({
  totalCount: 0,
  items: List(),
  _links: new TeamMaintainerSummaryLinks(),
  _isFetching: false,
}) {}

export const createTeamMaintainerSummary = (props?: CreateFunctionInput<TeamMaintainerSummary>) => {
  const teamMaintainerSummary =
    props instanceof TeamMaintainerSummary ? props : new TeamMaintainerSummary(fromJS(props));

  return teamMaintainerSummary.withMutations((summary) => {
    summary.update('items', (items) => items.map((maintainer) => createMemberSummary(maintainer)));
    summary.update('_links', (links) => new TeamMaintainerSummaryLinks(links));
  });
};
